// tslint:disable:max-line-length

import React from 'react';

export const EditorBackgroundImage = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M0,2v12h16V2H0z M14.5,12.5h-0.1L10,7L8.9,8.4l3.3,4.1h-2L5,6l-3.5,4.4V3.5h13V12.5z" />
    </svg>
  );
};
